'use strict';
(function() {
	angular.module('onboarding.services')
		.factory('observerService', observerService);

	observerService.$inject = ['$log'];

	function observerService($log) {
		return {
			sendMessageToSubject: sendMessageToSubject,
			createHandlerObject: createHandlerObject,
			registerHandlers: registerHandlers
		};

		function sendMessageToSubject(scope, subjectMessage, data) {
			scope.$emit(subjectMessage, subjectMessage, data);
		}

		function createHandlerObject(subjectMessage, handler) {
			return { message: subjectMessage, handler: handler };
		}

		function registerHandlers(scope, handlerObjectArray) {
			if (!handlerObjectArray || !angular.isArray(handlerObjectArray)) {
				$log.warn('Null or empty handlerObjectArray');

				return;
			}
			_.each(handlerObjectArray,
				function(ho) {
					scope.$on(ho.message,
						function(event, observerMessage, data) {
							//$log.debug("Observer received message " + observerMessage);
							ho.handler.call(this, data);
						});
				});
		}
	}
})();
